import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import config from "../config";
import {
  fetchUserAttributes,
  signInWithRedirect,
  getCurrentUser,
} from "@aws-amplify/auth";
import { Hub } from "aws-amplify/utils";
import { AmplifyEventBus } from "aws-amplify-vue";
import { signOut } from "../modules/auth";
import VpdEventBus from "../modules/vpd-event-bus";
import Accounts from "../views/Accounts.vue";
import Statements from "../views/Statements.vue";
import Services from "../views/Services.vue";
import AddServices from "../views/AddServices.vue";
import AddServicesSummary from "../views/AddServicesSummary.vue";
import ServicesTermsAndConditions from "../views/ServicesTermsAndConditions.vue";
import Login from "../views/Login.vue";
import ConfirmNewPass from "../views/ConfirmNewPass.vue";
import ConfirmOtp from "../views/ConfirmOtp.vue";
import Registration from "../views/Registration.vue";
import Activation from "../views/Activation.vue";
import UserProfile from "../views/UserProfile.vue";
import ChangePassword from "../views/ChangePassword.vue";
import ResetPass from "../views/ResetPass.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
import ComplaintPolicy from "../views/ComplaintPolicy.vue";
import Google from "../views/Google.vue";
import DeleteUser from "../views/DeleteUser.vue";
import Banks from "../views/Banks.vue";
import Consents from "../views/Consents.vue";
import Callback from "../views/Callback.vue";
import Page404 from "../views/404.vue";
import CookiePolicy from "../views/CookiePolicy.vue";
import CashbookSso from "../views/CashbookSso.vue";
import { redirectToOriginSubdomain } from "@/modules/origin-redirect-utils";
import store from "@/store";
import {
  handleSessionExpiry,
  isSessionExpiryError,
  resetSessionExpiryState,
} from "@/modules/session-expiry";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Home,
    name: "home",
    props: { config },
    meta: { requiresAuth: true, loadsStatementProcessorAccess: true },
    children: [
      {
        path: "",
        name: "defaultPath ",
        redirect: "accounts",
        props: { config },
      },
      {
        path: "accounts",
        name: "accounts",
        component: Accounts,
        props: { config },
        meta: { requiresAuth: true },
      },
      {
        path: "pdf-upload",
        name: "pdf-upload",
        component: Statements,
        props: { config },
        meta: { requiresAuth: true, requiresStatementProcessor: true },
      },
      {
        path: "services",
        name: "services",
        component: Services,
        props: { config },
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/add-services",
    name: "add-services",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: AddServices,
    props: { config },
    meta: { requiresAuth: true },
  },
  {
    path: "/oauth/callback/:bank",
    name: "oauth-handler",
    component: Callback,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      to.meta.props = {
        to: to,
      };
      next();
    },
  },
  {
    path: "/add-services-summary",
    name: "add-services-summary",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: AddServicesSummary,
    props: { config },
    meta: { requiresAuth: true },
  },
  {
    path: "/services-terms-and-conditions",
    name: "services-terms-and-conditions",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: ServicesTermsAndConditions,
    props: { config },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    props: { config },
    meta: { authEntry: true },
  },
  {
    path: "/logout",
    name: "logout",
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      await signOut();
      next({ name: "home" });
    },
  },
  {
    path: "/reset-pass",
    name: "resetPass",
    component: ResetPass,
    props: { config },
  },
  {
    path: "/confirm-otp",
    name: "confirmOtp",
    component: ConfirmOtp,
    props: { config },
  },
  {
    //TODO remove after e-mail renamed
    path: "/resetpass",
    name: "confirmNewpass",
    component: ConfirmNewPass,
    props: { config },
  },
  {
    path: "/confirm-newpass",
    name: "confirmNewpass",
    component: ConfirmNewPass,
    props: { config },
  },
  {
    path: "/registration",
    name: "registration",
    component: Registration,
    props: { config },
    meta: { authEntry: true },
  },
  {
    path: "/activation",
    name: "activation",
    component: Activation,
    props: { config },
    meta: { authEntry: true },
  },
  {
    path: "/userprofile",
    name: "userprofile",
    component: UserProfile,
    props: { config },
    meta: { requiresAuth: true, loadsStatementProcessorAccess: true },
  },
  {
    path: "/change-password",
    name: "change-password",
    component: ChangePassword,
    props: { config },
    meta: { requiresAuth: true },
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: PrivacyPolicy,
    props: { config },
  },
  {
    path: "/cookie-policy",
    name: "cookie-policy",
    component: CookiePolicy,
    props: { config },
  },
  {
    path: "/complaint-policy",
    name: "complaint-policy",
    component: ComplaintPolicy,
    props: { config },
  },
  {
    path: "/ggl",
    name: "google",
    component: Google,
    props: { config },
  },
  {
    path: "/deleteuser",
    name: "deleteuser",
    component: DeleteUser,
    props: { config },
    meta: { requiresAuth: true },
  },
  {
    path: "/banks",
    name: "banks",
    component: Banks,
    props: { config },
    meta: { requiresAuth: true },
  },
  {
    path: "/banks/:id",
    name: "invidual-banks",
    component: Consents,
    props: { config },
    meta: { requiresAuth: true },
  },
  {
    path: "/sso/succeeded",
    name: "cashbook-sso",
    component: CashbookSso,
    props: { config },
    meta: { requiresAuth: true },
  },
  {
    path: "/sso/failed",
    name: "cashbook-sso",
    component: CashbookSso,
    props: { config },
    meta: { requiresAuth: true },
  },
  /*{
      path: "/ws",
      name: "ws",
      component: () => import("../views/WsTest.vue"),
      props: { config },
      meta: { requiresAuth: true },
    },*/
  {
    path: "*",
    name: "404",
    component: Page404,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior() {
    document.getElementById('app').scrollIntoView({ behavior: 'auto' });
  }
});

const redirects = {
  signedOut: () => {
    // Login clears an earlier session before signing in. Keep its return URL.
    if (router.currentRoute.name !== "login") {
      router.push({ name: "login" }).catch(() => {});
    }
  },
  sessionExpired: () => {
    const currentRoute = router.currentRoute;
    const redirect =
      currentRoute.name && !currentRoute.meta.authEntry
        ? currentRoute.fullPath
        : undefined;

    router
      .replace({
        name: "login",
        query: redirect ? { redirect } : undefined,
      })
      .catch(() => {});
  },
  signUp: () => {
    router.push({ path: "registration" });
  },
  confirmSignUp: () => {
    router.push({ name: "confirm" });
  },
  signIn: () => {
    router.push({ name: "login" });
  },
  confirmOtp: () => {
    router.push({ name: "confirmOtp" });
  },
  signedIn: () => {
    const path = router.app.$route.query.redirect || "/";
    router.push({ path }).catch(() => { });
  },
  forgotPassword: () => {
    router.push({ name: "confirmNewpass" });
  },
  signIn_failure: () => {
  },
  redirect_federated: (provider) => {
    signInWithRedirect({ provider });
  },
};

AmplifyEventBus.$on("authState", async (state) => {
  if (typeof redirects[state] === "function") {
    const userState = state === "sessionExpired" ? "signedOut" : state;
    store.dispatch("general/userState", userState);

    if (state === "signedIn") {
      resetSessionExpiryState();
    }

    redirects[state]();
  }
});

VpdEventBus.$on("redirect", async (data) => {
  const entry = `redirect_${data.name}`;
  if (typeof redirects[entry] === "function") {
    redirects[entry](data.payload);
  }
});

Hub.listen("auth", (data) => {
  const state = data.payload.event;

  switch (state) {
    case "signedIn":
      AmplifyEventBus.$emit("authState", "signedIn");
      break;
    case "signIn_failure":
      break;
    case "tokenRefresh_failure":
      if (isSessionExpiryError(data.payload.data?.error)) {
        handleSessionExpiry();
      }
      break;
    default:
      break;
  }
});

router.beforeEach(async (to, from, next) => {
  await redirectToOriginSubdomain();
  next();
});

router.beforeResolve(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiresStatementProcessor = to.matched.some(
    (record) => record.meta.requiresStatementProcessor
  );
  const loadsStatementProcessorAccess = to.matched.some(
    (record) => record.meta.loadsStatementProcessorAccess
  );

  if (requiresAuth) {
    if (loadsStatementProcessorAccess) {
      router.app.$store.commit("general/statementProcessorEnabled", false);
      router.app.$store.commit("general/accountExportEnabled", false);
    }

    const pendingUser = localStorage.getItem("pendingUser");
    if (pendingUser) {
      console.log("[Router] Skipping auth check during OTP flow");
      if (requiresStatementProcessor) {
        return next({
          name: "login",
          query: {
            redirect: to.fullPath,
          },
        });
      }

      return next();
    }
    try {
      await getCurrentUser();
      router.app.$store.dispatch("general/userState", "signedIn");

      if (loadsStatementProcessorAccess) {
        let statementProcessorEnabled = false;
        let accountExportEnabled = false;

        try {
          const attributes = await fetchUserAttributes();
          statementProcessorEnabled =
            String(
              attributes?.["custom:isStatmntProcEnabled"] ?? ""
            ).toLowerCase() === "true";
          accountExportEnabled =
            String(
              attributes?.["custom:isAccountExport"] ?? ""
            ).toLowerCase() === "true";
        } catch (error) {
          console.warn("[Router] Failed to load user feature access", error);
        }

        router.app.$store.commit(
          "general/statementProcessorEnabled",
          statementProcessorEnabled
        );
        router.app.$store.commit(
          "general/accountExportEnabled",
          accountExportEnabled
        );

        if (requiresStatementProcessor && !statementProcessorEnabled) {
          return next({ name: "accounts" });
        }
      }

      return next();
    } catch (exception) {
      router.app.$store.commit("general/accountExportEnabled", false);
      return next({
        name: "login",
        query: {
          redirect: to.fullPath,
        },
      });
    }
  }
  next();
});

export default router;
